import {IAttributes, IAugmentedJQuery, IDirective, INgModelController, IQService, IScope} from "angular";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";
import {Throttle} from "../tjenester/Throttle";
import {BrukerRessurs} from "../tjenester/ressurser/BrukerRessurs";
import _ from "lodash";

export function validerBrukernavnOppdateresTilForInjisering() {
    return [regNavn.ng.$q, Throttle.regNavn, BrukerRessurs.regNavn, validerBrukernavnOppdateresTil];
}

/**
 * Validerer brukernavn vhja brukerRes.validerBrukernavnOppdateresTil(..).
 *
 * Eksponerer feilkoden 'i_bruk' under NgModelController.$error
 * Eksponerer feilkoden 'ugyldig_format' under NgModelController.$error
 */
export function validerBrukernavnOppdateresTil($q: IQService, throttle: Throttle, brukerRes: BrukerRessurs): IDirective {

    return {
        restrict: "A",
        require: 'ngModel',
        link: function ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes, $ctrl: INgModelController) {

            var throttledValider = throttle.throttle(
              (_brukernavn, $scope, $ctrl: INgModelController) => {
                  brukerRes.validerBrukernavnOppdateresTil($scope.$eval($attr['validerBrukernavnOppdateresTil']), _brukernavn)
                    .$promise
                    .then(resultat => {
                        $ctrl.$setValidity('i_bruk', !_.includes(resultat.feilkoder, 'i_bruk'))
                        $ctrl.$setValidity('ugyldig_format', !_.includes(resultat.feilkoder, 'ugyldig_format'))
                    });
              },
              1000);

            // bruker ikke $ctrl.$asyncValidators da vi ønsker å throttle serversidevalideringskallet og det
            // spiller ikke bra med semantikken til $ctrl.$asyncValidators
            // $viewChangeListeners vil ikke bli kalt før øvrige registrerte validatorer er OK
            // dog ser $viewChangeListeners ut til å bli ifbm første kjøring av øvrige validatorer
            $ctrl.$viewChangeListeners.push(() => {
                var brukernavn = $ctrl.$viewValue;
                if ($ctrl.$error && $ctrl.$error.brukernavn) return; //forhindrer kjøring hvis angular validering av brukernavn ikke er gyldig
                if ($ctrl.$error && $ctrl.$error.requiered) return; //forhindrer kjøring hvis angular validering av brukernavn ikke er gyldig
                throttledValider(brukernavn, $scope, $ctrl);
            });

        }
    };
}